import { isContentFragment } from '@oneaudi/falcon-tools';
import {
  Content,
  HeadlessContent,
  LinkWithCurrentPage,
  SECONDARYOPTIONS,
  StickyMode,
} from '../ContentType';
import { AppTheme } from '../context/ContextTypes';

const defaultLinkText = 'Link text placeholder';
const defaultHref = 'https://www.audi.de';

export const mapLinks = (content: HeadlessContent): LinkWithCurrentPage[] =>
  content.fields.links?.map((link) => ({
    href: link.fields.href || defaultHref,
    text: link.fields.text || defaultLinkText,
    ariaLabel: link.fields.ariaLabel || '',
    opensInNewTab: link.fields.opensInNewTab === true,
    currentPage: link.fields.currentPage === true,
  })) || [
    {
      text: defaultLinkText,
      href: defaultHref,
      ariaLabel: '',
      opensInNewTab: false,
      currentPage: false,
    },
  ];

function validateLinks(links: unknown): boolean {
  return Array.isArray(links) && links.every((link) => isContentFragment(link));
}

export const mapHeadlessContent = (content: Content | HeadlessContent): Content => {
  if (content && '__type' in content && content.__type === 'aem-headless') {
    const { fields } = content;
    const links = validateLinks(fields.links) ? mapLinks(content) : [];

    const cta =
      fields.cta_0_text &&
      fields.cta_0_text.length > 0 &&
      fields.cta_0_href &&
      fields.cta_0_href.length > 0
        ? [
            {
              text: fields.cta_0_text,
              href: fields.cta_0_href,
              ariaLabel: fields.cta_0_ariaLabel,
              opensInNewTab: fields.cta_0_opensInNewTab,
            },
          ]
        : [];

    const normalizedContent: Content = {
      headline: fields.headline || 'Headline Placeholder',
      links,
      secondaryCta: {
        secondaryOptions: fields.secondaryCta_secondaryOptions ?? 'none',
        shopNowCta:
          fields.secondaryCta_secondaryOptions === SECONDARYOPTIONS.VTP
            ? {
                text: fields.secondaryCta_shopNowCta_text ?? '',
                carlineId: fields.secondaryCta_shopNowCta_carlineId ?? '',
              }
            : { text: '', carlineId: '' },
        customCta:
          fields.secondaryCta_secondaryOptions === SECONDARYOPTIONS.CUSTOM
            ? {
                text: fields.secondaryCta_customCta_text ?? '',
                href: fields.secondaryCta_customCta_href ?? '',
                ariaLabel: fields.secondaryCta_customCta_ariaLabel ?? '',
              }
            : { text: '', href: '', ariaLabel: '' },
      },
      cta,
      lightDarkMode: fields.lightDarkMode ?? AppTheme.DARK,
      stickyMode: fields.stickyMode ?? StickyMode.STICKY,
      fascinationMode: fields.fascinationMode || false,
    };

    return normalizedContent;
  }

  return { ...content, fascinationMode: false } as Content;
};
